
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/save-on-electric-bills",
      function () {
        return require("private-next-pages/save-on-electric-bills/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/save-on-electric-bills"])
      });
    }
  